import { Button, Col, Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useRoutePath } from '~/hooks/useRoutePath';
import { Taxon } from '~/types/Taxon';
import { getChildren } from '~/utils/taxon';

interface MegaColumnProps {
  child: Taxon;
  taxonTree: Taxon[];
  openMobile: Record<string, boolean>;
  toggleMobile: (_code: Taxon['code']) => void;
  onHide: () => void;
  routePath: ReturnType<typeof useRoutePath>;
  renderImage: boolean;
}

const MegaColumn: React.FC<MegaColumnProps> = ({
  child,
  taxonTree,
  openMobile,
  toggleMobile,
  onHide,
  routePath,
  renderImage,
}) => {
  const { t } = useTranslation();
  const grandchildren = getChildren(taxonTree, child.code);

  const image = child.images?.[0]?.path;

  return (
    <Col lg={3} className={`mega-column${image ? ' mega-column--with-image' : ''}`}>
      <div className="d-flex align-items-center justify-content-between">
        <Nav.Link
          as={Link}
          to={routePath('category', child.slug)}
          onClick={onHide}
          className="mega__subcategory--level-1 d-flex align-items-center gap-3"
        >
          {image && renderImage && (
            <img
              src={image}
              alt={child.name}
              width={48}
              height={48}
              loading="lazy"
              fetchpriority="low"
              decoding="async"
              className="mega__column-image flex-shrink-0"
            />
          )}
          {child.name}
        </Nav.Link>

        {grandchildren.length > 0 && (
          <Button
            variant="link"
            className="p-0 d-lg-none mega__subtoggle"
            onClick={() => toggleMobile(child.slug)}
            aria-expanded={openMobile[child.slug]}
            aria-controls={`mega-sublist-${child.slug}`}
            aria-label={t('components.menu.expand_subcategory', { name: child.name })}
          />
        )}
      </div>

      {grandchildren.length > 0 && (
        <ul
          id={`mega-sublist-${child.slug}`}
          className={`list-unstyled ${openMobile[child.slug] ? 'show' : ''} mega__subcategory--level-2`}
        >
          {grandchildren.map((grand) => (
            <li key={grand.slug}>
              <Nav.Link as={Link} to={routePath('category', grand.slug)} onClick={onHide}>
                {grand.name}
              </Nav.Link>
            </li>
          ))}
        </ul>
      )}
    </Col>
  );
};

export default MegaColumn;
